(function corCartDrawer() {
  var drawer = document.querySelector('[data-cor-drawer]');
  if (!drawer) return;

  // Signal to the inline fallback guard in theme.liquid that the drawer owns add-to-cart.
  window.corCartDrawerReady = true;

  var body = drawer.querySelector('[data-cor-drawer-body]');
  var foot = drawer.querySelector('[data-cor-drawer-foot]');
  var subtotalEl = drawer.querySelector('[data-cor-drawer-subtotal]');
  var statusEl = drawer.querySelector('[data-cor-drawer-status]');
  var panel = drawer.querySelector('.cor-drawer__panel');
  var placeholder = drawer.getAttribute('data-cor-placeholder') || '';
  var lastFocused = null;
  var busy = false;

  function isHebrew() {
    return document.documentElement.classList.contains('cor-lang-he') ||
      document.documentElement.getAttribute('dir') === 'rtl';
  }

  function t(en, he) { return isHebrew() ? he : en; }

  function formatMoney(cents) {
    var n = Math.round((cents || 0) / 100);
    return '₪' + n.toLocaleString('en-US', { maximumFractionDigits: 0 });
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function applyLang() {
    if (typeof window.corApplyLanguage === 'function') {
      window.corApplyLanguage(isHebrew() ? 'he' : 'en');
    }
  }

  function updateBadge(count) {
    var bag = document.querySelector('.cor-header__bag');
    if (!bag) return;
    var badge = bag.querySelector('.cor-header__bag-count');
    if (count > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'cor-header__bag-count';
        badge.setAttribute('aria-hidden', 'true');
        bag.appendChild(badge);
      }
      badge.textContent = count;
    } else if (badge) {
      badge.remove();
    }
  }

  function itemRow(item) {
    var img = item.featured_image && item.featured_image.url ? item.featured_image.url : (item.image || placeholder);
    var variant = item.variant_title && item.variant_title !== 'Default Title'
      ? '<div class="cor-drawer-item__variant"><span data-cor-en="Size:" data-cor-he="מידה:">Size:</span> ' + escapeHtml(item.variant_title) + '</div>'
      : '';
    return '' +
      '<div class="cor-drawer-item" data-key="' + escapeHtml(item.key) + '">' +
        '<a class="cor-drawer-item__media" href="' + escapeHtml(item.url) + '">' +
          '<img src="' + escapeHtml(img) + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy" width="64" height="64">' +
        '</a>' +
        '<div class="cor-drawer-item__main">' +
          '<div class="cor-drawer-item__brand">' + escapeHtml(item.vendor || 'Code of the Road') + '</div>' +
          '<a class="cor-drawer-item__title" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a>' +
          variant +
          '<div class="cor-drawer-item__row">' +
            '<span class="cor-drawer-item__qty"><span data-cor-en="Qty" data-cor-he="כמות">Qty</span> ' + item.quantity + '</span>' +
            '<button type="button" class="cor-drawer-item__remove" data-cor-drawer-remove="' + escapeHtml(item.key) + '" data-cor-en="Remove" data-cor-he="הסרה">Remove</button>' +
          '</div>' +
        '</div>' +
        '<div class="cor-drawer-item__price">' + formatMoney(item.final_line_price) + '</div>' +
      '</div>';
  }

  function emptyState() {
    return '' +
      '<div class="cor-drawer__empty">' +
        (placeholder ? '<img src="' + escapeHtml(placeholder) + '" alt="" loading="lazy">' : '') +
        '<div class="cor-mono-overline" data-cor-en="Empty bag" data-cor-he="הסל ריק">Empty bag</div>' +
        '<p data-cor-en="Pick a helmet and the right size to get started." data-cor-he="בוחרים קסדה ומידה כדי להתחיל.">Pick a helmet and the right size to get started.</p>' +
      '</div>';
  }

  function render(cart) {
    if (!cart || !cart.items || cart.items.length === 0) {
      body.innerHTML = emptyState();
      foot.hidden = true;
    } else {
      body.innerHTML = cart.items.map(itemRow).join('');
      subtotalEl.textContent = formatMoney(cart.total_price);
      foot.hidden = false;
    }
    updateBadge(cart ? cart.item_count : 0);
    applyLang();
    if (statusEl) {
      var count = cart ? cart.item_count : 0;
      var total = formatMoney(cart ? cart.total_price : 0);
      statusEl.textContent = t(
        'Bag updated. ' + count + ' items, subtotal ' + total + '.',
        'הסל עודכן. ' + count + ' פריטים, סכום ביניים ' + total + '.'
      );
    }
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  // Focus management
  function focusables() {
    return Array.prototype.slice.call(
      panel.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])')
    ).filter(function (el) { return el.offsetParent !== null; });
  }

  function onKeydown(e) {
    if (e.key === 'Escape') { closeDrawer(); return; }
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function openDrawer() {
    if (!drawer.classList.contains('is-open')) {
      lastFocused = document.activeElement;
      drawer.hidden = false;
      // Force reflow so the open transition runs from the hidden state.
      void drawer.offsetWidth;
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', onKeydown, true);
      panel.focus();
    }
  }

  function closeDrawer() {
    if (!drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', onKeydown, true);
    var done = function () {
      drawer.hidden = true;
      panel.removeEventListener('transitionend', done);
    };
    panel.addEventListener('transitionend', done);
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  function setFormBusy(form, on) {
    form.querySelectorAll('[type="submit"]').forEach(function (btn) {
      btn.disabled = on;
      btn.classList.toggle('is-adding', on);
      if (on) btn.setAttribute('aria-busy', 'true'); else btn.removeAttribute('aria-busy');
    });
  }

  function addToCart(form) {
    if (busy) return;
    busy = true;
    setFormBusy(form, true);
    var data = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: data
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) { throw new Error(res.body && res.body.description || 'add failed'); }
        return getCart();
      })
      .then(function (cart) {
        render(cart);
        openDrawer();
      })
      .catch(function (err) {
        console.error('[cor-cart-drawer]', err);
        if (statusEl) {
          statusEl.textContent = t(
            'Could not add to bag. Opening cart…',
            'לא ניתן להוסיף לסל. פותח את הסל…'
          );
        }
        window.location.href = '/cart';
      })
      .finally(function () {
        busy = false;
        setFormBusy(form, false);
      });
  }

  function removeItem(key) {
    if (busy) return;
    busy = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        render(cart);
        // Keep focus inside the dialog after the body re-renders (the activated
        // Remove button was destroyed). Prefer the next Remove button, else the panel.
        var nextBtn = body.querySelector('[data-cor-drawer-remove]');
        (nextBtn || panel).focus();
      })
      .catch(function (err) { console.error('[cor-cart-drawer]', err); })
      .finally(function () { busy = false; });
  }

  // Intercept add-to-cart submits (capture phase, before any other handler).
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    if ((form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
    e.preventDefault();
    addToCart(form);
  }, true);

  // Open the drawer from the header bag icon instead of navigating to /cart.
  document.addEventListener('click', function (e) {
    var bag = e.target.closest && e.target.closest('.cor-header__bag');
    if (bag) {
      e.preventDefault();
      getCart().then(function (cart) { render(cart); openDrawer(); });
      return;
    }
    var closer = e.target.closest && e.target.closest('[data-cor-drawer-close]');
    if (closer) { e.preventDefault(); closeDrawer(); return; }
    var remove = e.target.closest && e.target.closest('[data-cor-drawer-remove]');
    if (remove) { e.preventDefault(); removeItem(remove.getAttribute('data-cor-drawer-remove')); }
  });
})();
